<div class="migrations-container">
  <div class="col-md-10 offset-md-1 d-flex flex-column h-100">
    <ziro-breadcrumbs>
      <ziro-breadcrumb-card-item [aboutCardId]="165"></ziro-breadcrumb-card-item>
    </ziro-breadcrumbs>

    <ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>
    @if (!isLoading) {
      <ul
        ngbNav
        #nav="ngbNav"
        [(activeId)]="activeTab"
        (navChange)="onNavChange($event)"
        class="nav-pills mb-3"
        data-automation="site-management-nav-tabs"
      >
        <li [ngbNavItem]="tabs.SITES" [destroyOnHide]="false">
          <a ngbNavLink class="btn nav-link" data-automation="site-management-tab-sites">
            {{ 'tkey;migrations.cisco.site_management.tabs.sites' | translate }}
          </a>
          <ng-template ngbNavContent>
            <div class="d-flex justify-content-end align-items-center gap-2 mb-3">
              <ziro-button
                [type]="buttonTypes.LINK"
                [buttonStyle]="buttonStyles.OUTLINE_DEFAULT"
                [buttonSize]="buttonSizes.SMALL"
                [icon]="icons.DOWNLOAD_SMALL"
                [label]="'tkey;migrations.cisco.site_management.sites.download_template' | translate"
                [href]="templateUrl"
                [downloadFileName]="'sites_template.csv'"
                [isDisabled]="isSaving"
                [dataAutomation]="'site-management-download-template'"
              ></ziro-button>
              <ziro-button
                [label]="'tkey;migrations.cisco.site_management.sites.import' | translate"
                [buttonStyle]="buttonStyles.OUTLINE_DEFAULT"
                [icon]="icons.IMPORT"
                [buttonSize]="buttonSizes.SMALL"
                [dataAutomation]="'network-site-bulk-import-subnets'"
                [isDisabled]="isSaving"
                (clicked)="importInput.click()"
              ></ziro-button>
              <input
                #importInput
                type="file"
                accept=".csv"
                class="d-none"
                data-automation="site-management-import-input"
                (change)="onImportFileSelected($event)"
              />

              <ziro-button
                [buttonStyle]="buttonStyles.PRIMARY"
                [buttonSize]="buttonSizes.SMALL"
                [icon]="icons.ADD"
                [label]="'tkey;migrations.cisco.site_management.bottom_nav.add_site' | translate"
                [isDisabled]="isSaving"
                [dataAutomation]="'site-management-add-site'"
                (clicked)="onAddSite()"
              ></ziro-button>
            </div>

            <fieldset
              class="site-management-fieldset"
              [disabled]="isSaving"
              data-automation="site-management-data-table"
            >
              <ziro-datatable
                [class]="'ziro-card site-management-table'"
                [dataAutomation]="'site-management-data-table'"
                [uniqueRowIdentifier]="'rowId'"
                [columns]="columns"
                [rowDataSource]="rows"
                [mainFilterPlaceholder]="'tkey;migrations.cisco.site_management.table.filter.placeholder' | translate"
                [noResultsAlert]="'tkey;migrations.cisco.site_management.no_results.message'"
                [matchesSecondaryDataFn]="matchesCountryNameFilter"
                (rowFieldChanged)="onRowFieldChange($event)"
              ></ziro-datatable>
            </fieldset>
          </ng-template>
        </li>

        <li
          [ngbNavItem]="tabs.SOURCE_FIELD_MAPPING"
          [destroyOnHide]="false"
          [disabled]="!hasSites"
          [disableTooltip]="hasSites"
          [ngbTooltip]="'tkey;migrations.cisco.site_management.tabs.source_field_mapping.disabled_tooltip' | translate"
        >
          <a ngbNavLink class="btn nav-link" data-automation="site-management-tab-source-field-mapping">
            {{ 'tkey;migrations.cisco.site_management.tabs.source_field_mapping' | translate }}
          </a>
          <ng-template ngbNavContent>
            <ziro-migrations-cisco-source-field-mapping
              (bottomNavStateChange)="onMappingsBottomNavStateChange($event)"
            ></ziro-migrations-cisco-source-field-mapping>
          </ng-template>
        </li>
      </ul>
      <div [ngbNavOutlet]="nav" class="site-management-nav-outlet flex-fill d-flex flex-column"></div>
    }
  </div>
</div>
